import { ScrapedEvent } from '../../types/api/ScrapedEvent';
import { Paper } from '@mui/material';

interface EventCardProps {
    event: ScrapedEvent
}
export function EventCard(EventCardProps: EventCardProps) {
    return (
        <Paper className="rounded shadow p-4 flex flex-col gap-1">
                <span className="font-bold">
                    🎉 {EventCardProps.event.title}
                </span>
                <span className="opacity-90">
                    📅 {EventCardProps.event.date}
                </span>
                <span className="opacity-90">
                    📍 {EventCardProps.event.location}
                </span>
        </Paper>
    );
}

export default EventCard;